import axios from 'axios';
import { apiService } from './api.service';
import { handleResponse, downloadFile, handleApiException } from '../helpers/apiResponseHelper';
import { IGhgEmissionReport } from '../models/ghg-emission-report';

function reportUrl(customerId: number, suffix: string = '') {
    return apiService.getApiUrl() + '/ghg-emission-reports/' + customerId + suffix;
}

async function getGhgEmissionReport(
    customerId: number, periodStart: string, periodEnd: string
): Promise<IGhgEmissionReport> {
    return axios.get(reportUrl(customerId), {
        params: { periodStart, periodEnd }
    }).then(handleResponse).catch(handleApiException);
}

async function getGhgEmissionReportFile(
    customerId: number, periodStart: string, periodEnd: string, type: 'pdf' | 'excel'
) {
    return axios.get(reportUrl(customerId, '/' + type), {
        params: { periodStart, periodEnd },
        responseType: 'blob'
    }).then(handleResponse).catch(handleApiException);
}

async function downloadGhgEmissionReportPdf(customerId: number, periodStart: string, periodEnd: string) {
    const url = reportUrl(customerId, '/pdf');
    const fileName = `KHG-heitkoguste-raport-${periodStart}_${periodEnd}.pdf`;
    return getGhgEmissionReportFile(customerId, periodStart, periodEnd, 'pdf')
        .then(res => downloadFile(fileName, res, url));
}

async function downloadGhgEmissionReportExcel(customerId: number, periodStart: string, periodEnd: string) {
    const url = reportUrl(customerId, '/excel');
    const fileName = `KHG-heitkoguste-raport-${periodStart}_${periodEnd}.xlsx`;
    return getGhgEmissionReportFile(customerId, periodStart, periodEnd, 'excel')
        .then(res => downloadFile(fileName, res, url));
}

const GhgEmissionReportService = {
    getGhgEmissionReport,
    downloadGhgEmissionReportPdf,
    downloadGhgEmissionReportExcel
};

export default GhgEmissionReportService;
